import { render, staticRenderFns } from "./PoliticaDescontoForm.vue?vue&type=template&id=8ea6f922&scoped=true&"
import script from "./PoliticaDescontoForm.vue?vue&type=script&lang=js&"
export * from "./PoliticaDescontoForm.vue?vue&type=script&lang=js&"
import style0 from "./PoliticaDescontoForm.vue?vue&type=style&index=0&id=8ea6f922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea6f922",
  null
  
)

export default component.exports